var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M23.1992 49.6117C35.7918 49.6117 46 39.1517 46 26.2485C46 13.3453 35.7918 2.88525 23.1992 2.88525C10.6067 2.88525 0.398438 13.3453 0.398438 26.2485C0.398438 39.1517 10.6067 49.6117 23.1992 49.6117Z",
    fill: "url(#paint0_radial_1_32430)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9297 24.8014V9.29263C32.9297 4.59219 29.211 0.781738 24.6237 0.781738L9.4883 0.781738C4.90102 0.781738 1.18229 4.59219 1.18229 9.29263V24.8014C1.18229 29.5018 4.90102 33.3123 9.4883 33.3123H24.6237C29.211 33.3123 32.9297 29.5018 32.9297 24.8014Z",
    fill: "url(#paint1_linear_1_32430)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5578 14.678C25.5578 13.6423 25.1563 12.649 24.4416 11.9167C23.7269 11.1844 22.7576 10.7729 21.7468 10.7729H11.975C10.9643 10.7729 9.99497 11.1844 9.28027 11.9167C8.56557 12.649 8.16406 13.6423 8.16406 14.678V19.3283C8.16406 19.8412 8.26264 20.3489 8.45416 20.8227C8.64568 21.2965 8.92639 21.727 9.28027 22.0896C9.63416 22.4522 10.0543 22.7398 10.5166 22.9361C10.979 23.1323 11.4746 23.2333 11.975 23.2333H21.7468C22.2473 23.2333 22.7429 23.1323 23.2052 22.9361C23.6676 22.7398 24.0877 22.4522 24.4416 22.0896C24.7955 21.727 25.0762 21.2965 25.2677 20.8227C25.4592 20.3489 25.5578 19.8412 25.5578 19.3283V14.678ZM19.825 17.3703L15.482 19.5954C15.3083 19.6844 14.7329 19.5954 14.7329 19.3617V14.8114C14.7329 14.6112 15.3192 14.4777 15.482 14.5778L19.673 16.9141C19.8142 16.992 19.9988 17.259 19.825 17.3703Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_32430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1992 26.2485) scale(22.8008 23.3632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_32430",
    x1: 30.4976,
    y1: 3.27382,
    x2: 2.97053,
    y2: 30.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.751c756e0885d81bab5e74224b55b0fd.svg";
export { ForwardRef as ReactComponent };